// removed by extract-text-webpack-plugin
module.exports = {"container":"replyOptions-module-container-7bd3b17b78dc8c56e05c99e7c065d1aa--"};


//////////////////
// WEBPACK FOOTER
// /src/components/mailThread/mail/replyOptions/replyOptions.module.scss
// module id = 1935
// module chunks = 0